import { InvoiceApiStatusType as InvoiceStatus } from 'anchor-scout-common/types';
import { isPartiallyTaxable, isTaxMarked } from '../bundle-tax';
export { InvoiceStatus };
export function isItemMarkedTaxable(item) {
    const { taxability } = item;
    return taxability.source !== 'none' && taxability.taxable;
}
function taxMarks(item) {
    var _item_subItems;
    return {
        ownMark: isItemMarkedTaxable(item),
        childMarks: ((_item_subItems = item.subItems) !== null && _item_subItems !== void 0 ? _item_subItems : []).map(isItemMarkedTaxable)
    };
}
export function isLineTaxMarked(item) {
    return isTaxMarked(taxMarks(item));
}
export function isPartiallyTaxableBundle(item) {
    return isPartiallyTaxable(taxMarks(item));
}
export function itemPeriod(item) {
    const { period } = item;
    if (period.type === 'delivery') return null;
    if (period.type === 'fullTerm') return {
        from: period.from,
        to: period.to,
        proRata: null
    };
    return {
        from: period.from,
        to: period.to,
        proRata: period.proRata
    };
}
